import { ApplicationController } from "../application_controller";

export default class extends ApplicationController {
  static targets = ["contracts_table", "tab_content_url"];


  connect() {
    if (this.hasContracts_tableTarget) {
      this.loadContractsTable();
    }
  }

  async loadContractsTable() {
    const url = this.data.get("tab-content-url");
    const tab_target = this.contracts_tableTarget;

    fetch(url, {
      method: 'GET',
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].getAttribute('content'),
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/html',
        'Accept': 'application/html'
      },
      credentials: 'same-origin'
    }).then((response) => {
      if (response.status == 200) {
        response.text().then((content) => {
          tab_target.innerHTML = content;
        })
      }
    });
  }


}